<template>
  <div>
    <CContainer>
      <CRow class="justify-content-center mt-4">
        <CCol md="12 text-center">
          <h1 class="mb-4">Help Desk</h1>
          <div>
            <iframe
              src="https://docs.google.com/document/d/e/2PACX-1vTgDhe0g6mupHl1cQ1VFUeOGc8TsIubljMBSqZStzY3hcxlwMg_Cxg8RlONbnbADuQpsmjFX9BH9rxJ/pub?embedded=true"
              class="trainings-iframe centered-content-iframe"
            />
          </div>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>
<script>
import { mapGetters } from "vuex"

export default {
  name: "VideoTraining",
  computed: {
    ...mapGetters({
      trainings: "releases/trainings",
      user: "authentication/user"
    })
  },
  created() {
    this.$store.dispatch("releases/getTrainings")
  }
}
</script>
